// src/services/api/callCenterSummaryReport.js
import { apiClient } from './base';

/**
 * Get filter options for the Call Center Summary report (date presets)
 */
export const getCallCenterSummaryFilters = async () => {
  try {
    const response = await apiClient.get('/callcenter-summary/filters');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the 8 KPI summary cards for the selected date range
 * @param {Object} params - { dateFrom, dateTo }
 */
export const getCallCenterSummaryKpis = async (params) => {
  try {
    const response = await apiClient.get('/callcenter-summary/summary-cards', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get achievement gauge data for the selected date range (defaults to today when omitted).
 * @param {Object} params - { dateFrom, dateTo }
 */
export const getCallCenterTodayAchievement = async (params = {}) => {
  try {
    const response = await apiClient.get('/callcenter-summary/today-achievement', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the last 7 real days' achieved-vs-target series.
 * Always trailing 7 real days — takes no date params.
 */
export const getCallCenterLast7DaysTrend = async () => {
  try {
    const response = await apiClient.get('/callcenter-summary/last-7-days-achieved-target');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get top cross-selling products for the selected date range. Always global (never agent-scoped).
 * @param {Object} params - { dateFrom, dateTo, limit }
 */
export const getCallCenterCrossSellProducts = async (params) => {
  try {
    const response = await apiClient.get('/callcenter-summary/top-products', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get per-agent target vs achieved cross-sell value, top N.
 * @param {Object} params - { dateFrom, dateTo, limit }
 */
export const getCallCenterTargetPerAgent = async (params) => {
  try {
    const response = await apiClient.get('/callcenter-summary/target-per-agents', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the general confirmed-order leaderboard, paginated.
 * @param {Object} params - { dateFrom, dateTo, page, limit }
 */
export const getCallCenterAgentPerformance = async (params) => {
  try {
    const response = await apiClient.get('/callcenter-summary/agent-performance', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
